import { render } from "./DaftarSocial.vue?vue&type=template&id=84ffa77c"
import script from "./DaftarSocial.vue?vue&type=script&lang=js"
export * from "./DaftarSocial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__